export const VintageBeach = {
    backGround: '#FFF',
    base1: '#A8DADC',
    base2: '#457B92',
    base3: '#1D3557',
    accent: '#E94957',
}